<template>

    <div class="col-lg-6">
        <div class="card  blog-edit-wrapper" >
            <div class="card-body">
                <!-- Form -->
                <h3>Create an Access Token</h3>
                <form action="javascript:;" class="mt-2" v-on:submit.prevent="publishVideo">
                    <div class="row">
                        
                        <div class="col-md-6 col-12">
                            <div class="form-group mb-2">
                                <label for="client_id">client id</label>
                                <b-form-input
                                    id="client_id"
                                    v-model="client_id"
                                    placeholder="client id"
                                />
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <div class="form-group mb-2">
                                <label for="client_secret">client secret</label>
                                <b-form-input
                                    id="client_secret"
                                    v-model="client_secret"
                                    type="password"
                                    placeholder="client secret"
                                />
                            </div>
                        </div>

                        <div class="col-md-12 col-12">
                            <div class="form-group mb-2">
                            <label for="grant_type">grant type</label>
                            <b-form-input
                                id="grant_type"
                                v-model="grant_type"
                                placeholder="grant type"
                            />
                            </div>
                        </div>
                        <div class="col-md-12 col-12">
                            <div class="form-group mb-2">
                                <label for="code">code</label>
                                <b-form-input
                                id="code"
                                v-model="code"
                                placeholder="code"
                                />
                            </div>
                        </div>
                        <div class="col-12 mt-50">
                            <button id="generateAccessToken" type="button" class="btn btn-primary mr-1"  v-on:click="generateAccessToken()">Generate GoHighLevel Access Token</button>
                        </div>
                    </div>
                </form>
                <!--/ Form -->
            </div>
        </div>
    </div>

</template>
<script>
import { ref } from 'vue'
import {BFormInput} from 'bootstrap-vue-3'
import 'vue-advanced-cropper/dist/style.css';
import 'vue-select/dist/vue-select.css';
import { useSettingStore } from '../../stores/SettingStore.js'

export default{
    components:{
    },
    data(){
        return {
            client_id : "",
            client_secret : ref(null),
            grant_type : ref('authorization_code'),
            code:ref(null),
            settingStore: useSettingStore(),
        }
    },
    watch:{
        'settingStore.gohighlevel_clients'(value) {
            this.client_id = value.client_id
            this.client_secret = value.client_secret
        }
    },

    mounted(){    
    },
    methods:{
        generateAccessToken(){
            if(this.code != "" || this.code != undefined || this.code != null){
                const route = this.$router.resolve(
                    {
                        name: 'generate-gohighlevel-access-token',
                    }
                );
                axios.post(
                    route.href,
                    {
                        client_id : this.client_id,
                        client_secret : this.client_secret,
                        grant_type : this.grant_type,
                        code : this.code,
                    }
                )
                .then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            }else{
                toastr.error('Please fill in the required field and try again', 'Error!');
            }
            
            
            
        },
    }
}
</script>
